import { EditOutlined, LayoutOutlined } from '@ant-design/icons'
import { SiteBean } from 'common/api/api.ts';
import { GoToReportButton } from 'common/components/GoToReportButton.tsx';
import { ListActionButton } from 'common/components/ListActionButton.tsx';
import { CommonRoutes } from 'common/context/commonRoutes';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
    record: SiteBean
}

export const SiteActionBar: React.FC<Props> = ({ record }) => {
    const navigateTo = useNavigate()

    return (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
            <ListActionButton tooltip="Ad Units" onClick={() => navigateTo(`${CommonRoutes.AD_UNIT}/${record.id}#site`)}>
                <LayoutOutlined />
            </ListActionButton>
            <GoToReportButton title="Reports" filterName="SiteId" id={record.id} />
            <ListActionButton htmlType="button" tooltip="Edit" onClick={() => navigateTo(`${CommonRoutes.SITE}/${record.id}/edit`)}>
                <EditOutlined />
            </ListActionButton>
        </div>
    )
}
